import { sv } from './sv';
import { en } from './en';
export const translationsObject = {
  sv,
  en
};
